import React, { createContext, useContext, useState, useMemo } from 'react';
import { VantifyContextType, VantifyContextProviderProps, VantifyAuth, VantifyUser } from './types';
import { ContentType } from 'application-types';

const VantifyContext = createContext<VantifyContextType | undefined>(undefined);

export const VantifyContextProvider = ({ children }: VantifyContextProviderProps) => {
  const [auth, setAuth] = useState<VantifyAuth | null>(null);
  const [user, setUser] = useState<VantifyUser | null>(null);
  const [content, setContent] = useState<ContentType | null>(null);

  const value = useMemo(() => ({ auth, setAuth, user, setUser, content, setContent }), [auth, user, content]);

  return (
    <VantifyContext.Provider value={value}>
      {children}
    </VantifyContext.Provider>
  );
};

export const useVantifyContext = () => {
  const context = useContext(VantifyContext);

  if (!context) {
    throw new Error('useVantifyContext must be used within a VantifyContextProvider');
  }

  return context;
};